import { I18n } from '@calendly/i18n';
import { BareButton } from '@calendly/ui/components/bare-button';
import { useDropdown } from '@calendly/ui/components/dropdown';
import { ArrowChevronDownMiniIcon, ArrowChevronUpMiniIcon } from '@calendly/ui/components/icons';
import { Menu, BareItem } from '@calendly/ui/components/menu';
import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import { primaryColorL1 } from '@calendly/ui/theme';
import classNames from 'classnames';
import { useContext, useEffect, useMemo, useState, forwardRef } from 'react';
import { SectionHeader } from './styles';
import { MeetingDetailDependenciesContext } from '../../meeting_detail_context';
const containerCss = "cg0m3rf";
const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});
const dropdownButtonCss = "d1gm66oe";
const DropdownButton = forwardRef((props, ref) => <BareButton ref={ref} {...props} className={classNames(dropdownButtonCss, props.className)} />);
const styledMenuCss = "s1bfcbtx";
const StyledMenu = forwardRef((props, ref) => {
  const isPhone = useDeviceType('isPhone');
  return <Menu ref={ref} {...props} isPhone={isPhone} className={classNames(styledMenuCss, props.className)} />;
});
const styledBareItemCss = "s1lpnwho";
const StyledBareItem = forwardRef((props, ref) => <BareItem ref={ref} {...props} className={classNames(styledBareItemCss, props.className)} />);
const bodyCss = "b8n1at4";
const Body = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(bodyCss, props.className)} />;
});
export const AttendeeSelector = ({
  selectedEvent,
  onSelect
}) => {
  const [page, setPage] = useState(1);
  const dependencies = useContext(MeetingDetailDependenciesContext);
  if (!dependencies?.useGetInviteesQuery) {
    throw new Error('AttendeeSelector must be wrapped in a MeetingDetailDependenciesProvider with useGetInviteesQuery');
  }

  // Dashboard invitees API expects numeric event id; fall back to uuid for share/legacy
  const eventIdForInvitees = selectedEvent?.id ?? selectedEvent?.uuid;
  const {
    data
  } = dependencies.useGetInviteesQuery({
    eventId: eventIdForInvitees,
    page
  }, {
    skip: !eventIdForInvitees
  });
  const [selectedInvitee, setSelectedInvitee] = useState({});
  const [toggle, Dropdown, isExpanded] = useDropdown();
  const invitees = useMemo(() => {
    const results = data?.results || [];
    return [...results].sort((a, b) => a.name.localeCompare(b.name));
  }, [data]);
  useEffect(() => {
    if (invitees.length > 0) {
      setSelectedInvitee(invitees[0]);
      onSelect(invitees[0]);
    } else {
      setSelectedInvitee({});
      onSelect({});
    }
  }, [invitees, setSelectedInvitee, onSelect]);
  useEffect(() => {
    if (isExpanded && data?.pagination?.nextPage) {
      setPage(prevPage => prevPage + 1);
    }
  }, [isExpanded, data?.pagination?.nextPage]);
  const handleSelect = invitee => {
    setSelectedInvitee(invitee);
    onSelect(invitee);
    toggle();
  };
  return <Container>
      <SectionHeader expanded>
        {I18n.t('publisher.meeting_intelligence.details.questions.show_answers_for')}
      </SectionHeader>
      <Body>
        <div>
          <DropdownButton onClick={toggle}>
            {selectedInvitee?.name}
            {isExpanded ? <ArrowChevronUpMiniIcon color={primaryColorL1} /> : <ArrowChevronDownMiniIcon color={primaryColorL1} />}
          </DropdownButton>
          <Dropdown>
            <StyledMenu>
              {invitees.map(invitee => <StyledBareItem key={invitee.id} onClick={() => handleSelect(invitee)}>
                  {invitee.name}
                </StyledBareItem>)}
            </StyledMenu>
          </Dropdown>
        </div>
      </Body>
    </Container>;
};

require("./attendee_selector.wyw-in-js.css!=!../../../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./attendee_selector.js");